import React from 'react'
import strings from '../../../lang/strings'

export default function TableCellBettingResult(props) {

  const {betting_type, home, away, winScore, winUp, loseScore, loseUp, drawScore, drawUp, handi, uo, selected, ans, onSelectChange} = props

  return (
    <div className={'d-flex ' + props.className}>
      <div className='w-30 d-center h-100 fs-16 sm-fs-14 color-3a3335 ph-10 sm-ph-5 td-betting-result'>{home}
        {handi != 0 &&
        <div className='fs-14 sm-fs-12 mt-2 color-e45a5a'>&nbsp;(H{handi})</div>
        }
        {uo != 0 &&
        <div className='fs-14 sm-fs-12 mt-2 color-3a6d99'>&nbsp;(U/O{uo})</div>
        }
        {betting_type == 3 &&
        <div className='fs-14 sm-fs-12 mt-2 color-9c39cf'>&nbsp;({strings.win1loss})</div>
        }
      </div>
      <div className='w-20 d-center h-100 fs-16 sm-fs-14 color-3a3335 ph-10 sm-ph-5 td-betting-result'>{away}</div>
      <div className='w-17 d-center h-100 td-betting-result d-center cursor-point' onClick={() => {onSelectChange(0)}}>
        <img className='' src={selected === 0 ? '/assets/image/chk2_on.png' : '/assets/image/chk2.png'} alt='' width={18} height={18} />
        <div className={'color-3a6d99 fs-16 sm-fs-14 ml-4 sm-ml-2' + (ans == 0 ? ' bg-fff500' : '')}>{(betting_type==2 ? (strings.u + ' ') : betting_type == 4 ?  (strings.odd + ' ') : (strings.win + ' ')) + winScore}</div>
        <img className='ml-2' hidden={winUp == 0} src={winUp < winScore ? '/assets/image/a7_u.png' : '/assets/image/a7_d.png'} alt='' width={13} />
      </div>
      {drawScore > 0 &&
      <div className='w-17 d-center h-100 td-betting-result d-center cursor-point' onClick={() => {onSelectChange(1)}}>
        <img className='' src={selected === 1 ? '/assets/image/chk2_on.png' : '/assets/image/chk2.png'} alt='' width={18} height={18} />
        <div className={'color-3a3335 fs-16 sm-fs-14 ml-4 sm-ml-2' + (ans == 1 ? ' bg-fff500' : '')}>{(betting_type == 4 ? strings.one : strings.draw) + ' ' + drawScore}</div>
        <img className='ml-2' hidden={drawUp == 0} src={drawUp < drawScore ? '/assets/image/a7_u.png' : '/assets/image/a7_d.png'} alt='' width={13} />
      </div>
      }
      {drawScore == 0 && <div className='w-17 d-center h-100 fs-16 sm-fs-14 color-3a3335 ph-10 sm-ph-5 td-betting-result'>{'-'}</div>}
      <div className='w-17 d-center h-100 td-betting-result d-center cursor-point' onClick={() => {onSelectChange(2)}}>
        <img className='' src={selected === 2 ? '/assets/image/chk2_on.png' : '/assets/image/chk2.png'} alt='' width={18} height={18} />
        <div className={'color-fa2222 fs-16 sm-fs-14 ml-4 sm-ml-2' + (ans == 2 ? ' bg-fff500' : '')}>{(betting_type==2 ? (strings.o + ' ') : betting_type == 4 ?  (strings.even + ' ') :(strings.lose + ' ')) + loseScore}</div>
        <img className='ml-2' hidden={loseUp == 0} src={loseUp < loseScore ? '/assets/image/a7_u.png' : '/assets/image/a7_d.png'} alt='' width={13} />
      </div>
    </div>
  )
}

